import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';
import Timestamp from 'react-timestamp';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { Link } from 'react-router-dom';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import { deleteVoucher, putVoucher } from '../../store/vouchers/actions';
import { VOUCHERS } from '../../constants/routes';

const styles = () => ({
  fabProgress: {
    color: 'primary',
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  row_container_disabled: {
    backgroundColor: orange[500]
  },
  row_container_off_line: {
    backgroundColor: red[500]
  }
});

export class VoucherRow extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      sendingVoucherId: '',
      role: ROLE_USER
    };
  }

  static propTypes = {
    classes: PropTypes.object.isRequired,
    voucher: PropTypes.object.isRequired
  };

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };
    }
    if (!props.sending && state.sendingVoucherId) {
      newState = { ...newState, sendingVoucherId: null };
    }
    return newState;
  }

  // Handle

  handleDeleteVoucher = (event) => {
    this.setState({ sendingVoucherId: this.props.voucher.id});
    this.props.deleteVoucher(
      this.props.authUser.ma,
      this.props.voucher.id,
      this.props.voucher
    );
    event.preventDefault();
  };

  // Computation

  rowClassName = (voucher) => {
    if ((voucher.type === 0 && voucher.rents && voucher.rents.length > 0)
      || (voucher.end_date && voucher.end_date < (Date.now() / 1000 | 0))) {
      return this.props.classes.row_container_off_line;
    }
    if ((voucher.type !== 1 && voucher.rents &&  voucher.rents.length > 0) ) {
      return this.props.classes.row_container_disabled;
    }
    return null;
  };

  typeString = (type) => {
    switch (type) {
      case 0:
        return "USAGE UNIQUE";
      case 1:
        return "ABONNEMENT";
      case 2:
        return "USAGE MULTIPLE";
    }
  };

  render() {
    const { voucher } = this.props;

    const { role } = this.state;

    return (

      <TableRow
        key={voucher.id}
        hover
        tabIndex={-1}
        className={this.rowClassName(voucher)}
      >
        <TableCell>{voucher.code}</TableCell>
        <TableCell>{this.typeString(voucher.type)}</TableCell>
        {(role === ROLE_ADMIN) &&
        <TableCell>{voucher.renterName}</TableCell>
        }
        <TableCell>{voucher.siteName}</TableCell>
        <TableCell>{voucher.value / 100}</TableCell>
        <TableCell>{voucher.percent}</TableCell>
        <TableCell>
          <Timestamp
            format='full'
            twentyFourHour
            time={voucher.end_date}
          />
        </TableCell>
        <TableCell padding="checkbox">
          <Tooltip title="Modifier">
            <IconButton aria-label="update"
                        component={Link}
                        to={`${VOUCHERS}/${voucher.id}`}>
              <EditIcon/>
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }

}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
    sending: state.vouchers.sending
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { putVoucher, deleteVoucher }),
)(VoucherRow);



// WEBPACK FOOTER //
// ./src/components/Voucher/VoucherRow.jsx